import { NgIf } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Product, ProductVariant } from 'src/app/classes/utility';
import { ShopifyService } from 'src/app/service/shopify.service';
import { ThemeService } from 'src/app/service/theme.service';

@Component({
  selector: 'app-add-to-cart',
  imports: [NgIf, RouterModule],
  templateUrl: './add-to-cart.component.html',
  styleUrl: './add-to-cart.component.scss',
})
export class AddToCartComponent implements OnInit {
  @Input() product!: Product;
  @Input() _selectedVariant!: ProductVariant;
  _text: string = 'Loading';
  _purchaseable: 'add' | 'backorder' | 'preorder' | 'outofstock' | 'loading' =
    'loading';
  form: any;
  status: string = 'VALID';
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private shopifyService: ShopifyService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this._purchaseable = 'loading';
    this._text = 'Loading';
    this.calculatePurchaseable();
  }

  calculateAddToCartMessage() {
    this._text = 'Add to Bag';
  }

  calculatePurchaseable() {
    if (
      this._selectedVariant.inventory_policy === 'DENY' &&
      this._selectedVariant.inventory_quantity <= 0
    ) {
      this._purchaseable = 'outofstock';
      this._text = 'Out of Stock';
      return;
    }
    if (this.status === 'INVALID') {
      this._purchaseable = 'outofstock';
      this._text = 'Form incomplete';
      return;
    }
    this.calculateAddToCartMessage();
    this._purchaseable = 'add';
  }

  addToCart() {
    const originalText = this._text;
    this._text = 'Adding...';
    this.shopifyService
      .addToCart([
        {
          variantId: 'gid://shopify/ProductVariant/' + this._selectedVariant.id,
          quantity: 1,
          attributes: Object.keys(this.form ?? {})
            .map((x) => {
              return {
                key: x,
                value: this.form[x],
              };
            })
            .filter((x) => x.value !== ''),
        },
      ])
      .subscribe({
        next: (data: any) => {
          this._text = 'Added To Cart!';
          this.themeService.deployToasts(
            [this._selectedVariant.admin_graphql_api_id],
            data
          );
        },
        error: () => {
          this._text = 'Error Adding to Cart';
        },
        complete: () => {
          setTimeout(() => {
            this._text = originalText;
          }, 3000);
        },
      });
  }
}
